export default "__VITE_ASSET__B9V4Smv5__"